import React, { Component } from 'react';
import styles from './styles.scss';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import {
  deviceCategoryId,
  pagePathId
} from '../../pages/ReportBuilder/constants';

export const CAMPAIGN_ANALYTICS_TOPICS = 'campaign_analytics_topics';
export const deviceCategoryAndPagePathOptions = [deviceCategoryId, pagePathId];
class CampaignAnalyticsTopics extends Component {
  static propTypes = {
    title: string,
    description: string,
    data: arrayOf(shape({})),
    onChange: func,
    disabledListItem: arrayOf(string),
    isDeviceCategoryAndPagePath: bool
  };

  static defaultProps = {
    title: 'Campaign Dashboard Data',
    description:
      `Select from the below list of available analytics data which displays as tabs on your various advertisers' campaign dashboards. Please note Location and Channels data availability is determined by web data source.`
  };

  handleChange = event => {
    const { onChange, data } = this.props;
    const key = event.target.value || '';
    const newData = data.map(item => {
      if (item.key === key) {
        return {
          ...item,
          isSelected: !item.isSelected,
        }
      }
      return item;
    });
    onChange &&
      onChange({
        setting_name: CAMPAIGN_ANALYTICS_TOPICS,
        setting_value: newData
      });
  };

  chunkData = data => {
    const chunkLength = Math.round(data.length / 2);
    const firstHalf = data.slice(0, chunkLength);
    const secondHalf = data.slice(chunkLength, data.length);
    return {
      firstHalf,
      secondHalf
    };
  };

  drawTopicsColumn = data => {
    const { disabledListItem } = this.props;
    return (
      <div className={styles.settingListItem}>
        {data &&
          data.map(item => {
            const unselectedCheckBox = disabledListItem.includes(item.key);
            return (
              <FormControlLabel
                key={item.id}
                className={styles.topicsItem}
                classes={{
                  label: styles.labelText
                }}
                control={
                  <Checkbox
                    color="primary"
                    checked={
                      unselectedCheckBox ? unselectedCheckBox : item.isSelected
                    }
                    onChange={this.handleChange}
                    value={item.key}
                    disabled={unselectedCheckBox}
                  />
                }
                label={item.displayName}
              />
            );
          })}
      </div>
    );
  };

  render() {
    const {
      title,
      description,
      data,
      isDeviceCategoryAndPagePath
    } = this.props;

    const newCampaignAnalyticsTopics = isDeviceCategoryAndPagePath
      ? data
      : data.filter(obj => !deviceCategoryAndPagePathOptions.includes(obj.key));

    const { firstHalf, secondHalf } = this.chunkData(
      newCampaignAnalyticsTopics
    );

    return (
      <div className={styles.campaignAnalyticsTopicsContainer}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.settingListContainer}>
          {this.drawTopicsColumn(firstHalf)}
          {this.drawTopicsColumn(secondHalf)}
        </div>
      </div>
    );
  }
}

export default CampaignAnalyticsTopics;
